<template>
  <div
    id="users"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
        :headers="headers"
        :api-u-r-l="apiURL"
        :title="title"
        :readonly="true"
        :back="true"
        back-u-r-l="enterprises"
      />
    </div>
  </div>
</template>

<script>
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    VuetifyTable,
  },
  props: {
    enterpriseId: { default: '' },
    action: { default: '' },
    message: { default: '' },
  },
  data: () => ({
      headers: [
       {
          text: 'Usuario de Integración',
          value: 'userws',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Email',
          value: 'email_address1',
          align: 'left',
          sortable: true,
        },
        {
          text: 'Acciones',
          value: 'action',
          sortable: false,
        },
      ],
      name: '',
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.enterpriseId}/integrations`;
    },
    title() {
      return `Integraciones de <b>${this.name}</b>`;
    },
  },
  mounted() {
    window.axios.get(`/api/enterprises/${this.enterpriseId}`)
    .then((result) => {
      this.name = `${result.data.name} - ${result.data.ruc}`;
    });
  },
};
</script>
